import { SHOPIFY_VARIANTS, SHOPIFY_ADDONS } from "../data/products";

const EXTRA_MATCHERS = [
    [/bruma|victoria/i, SHOPIFY_ADDONS.bruma],
    [/ferrero/i, SHOPIFY_ADDONS.ferrero],
    [/tarjeta|romantic card/i, SHOPIFY_ADDONS.tarjeta],
    [/rosa|rose/i, SHOPIFY_ADDONS.rosa],
];

/* ID de l'addon Shopify correspondant à un extra (par nom, ES ou EN). */
export function extraAddonId(name) {
    const hit = EXTRA_MATCHERS.find(([re]) => re.test(String(name)));
    return hit ? hit[1] : undefined;
}

export const ADDON_KEYS = [
    "Globo de corazón con helio",
    "Escritura en el globo",
    "Texto globo/embalaje",
];

const ADDON_IDS = {
    "Globo de corazón con helio": SHOPIFY_ADDONS.globo,
    "Escritura en el globo": SHOPIFY_ADDONS.escritura,
    "Texto globo/embalaje": SHOPIFY_ADDONS.persoPack,
};

const ATTR_KEYS = ["Dirección", "Código postal", "Fecha de entrega", "Franja horaria", "Destinatario", "Teléfono", "Lugar", "Información adicional", "Mensaje tarjeta"];

export function buildShopifyCheckout(items) {
    const lines = [];
    const attrs = [];
    let n = 0;
    items.forEach((it) => {
        const opt = it.options || {};
        n += 1;
        const prefix = items.length > 1 ? `#${n} ` : "";
        let vid;
        if (it.productId === "fresh-roses")
            vid = SHOPIFY_VARIANTS["fresh-roses"][String(opt.roseCount)];
        else if (it.productId === "romantic-pack-supreme")
            vid = SHOPIFY_VARIANTS["romantic-pack-supreme"][String(opt.roseCount)];
        else if (it.productId === "surprise-box-balloons")
            vid = SHOPIFY_VARIANTS["surprise-box-balloons"].default;
        else if (it.productId === "custom-teddy") {
            const shirtKey =
                opt.shirt && opt.shirtColor ? String(opt.shirtColor).toLowerCase() : "none";
            vid = SHOPIFY_VARIANTS["custom-teddy"][`${opt.teddyColor}|${shirtKey}`];
        }
        if (!vid) return;
        lines.push(`${vid}:${it.qty}`);

        (opt.properties || []).forEach(([k, v]) => {
            if (k === "Extra") {
                const hit = EXTRA_MATCHERS.find(([re]) => re.test(v));
                if (hit) lines.push(`${hit[1]}:${it.qty}`);
            } else if (ADDON_KEYS.includes(k)) {
                lines.push(`${ADDON_IDS[k]}:${it.qty}`);
            }
        });
        if (opt.shirtText) lines.push(`${SHOPIFY_ADDONS.textoTshirt}:${it.qty}`);

        const push = (k, v) => {
            if (v !== undefined && v !== null && String(v).trim()) attrs.push([`${prefix}${k}`, String(v)]);
        };
        if (opt.roseCount) push("Formato", `${opt.roseCount} rosas`);
        if (opt.teddyColorLabel) push("Color", opt.teddyColorLabel);
        if (opt.shirt && opt.shirtColorLabel) push("T-shirt", opt.shirtColorLabel);
        if (opt.shirtText) push("Texto en el T-shirt", opt.shirtText);
        if (opt.packExtra) push("Personalización del Pack", "Sí");
        if (opt.cardStyleLabel) push("Tarjeta", opt.cardStyleLabel);
        if (opt.message) push("Mensaje", opt.message);
        (opt.properties || []).forEach(([k, v]) => {
            if (k === "Extra" || ADDON_KEYS.includes(k)) return; // déjà en ligne dédiée
            if (ATTR_KEYS.includes(k)) push(k, v);
        });
    });
    return { items: lines.map((l) => { const [variantId, qty] = l.split(":"); return { variantId, qty: Number(qty) }; }), attributes: Object.fromEntries(attrs) };
}